import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import AccountPopover from 'src/components/Layout/AccountPopover';
import MobileSidebar from 'src/components/MobileSidebar';
import { ReactComponent as SettingsLogo } from 'src/Images/icons/common/settings.svg';
import { ReactComponent as NineDotsLogo } from 'src/Images/icons/navbar/nine-dots.svg';
import { ReactComponent as SearchLogo } from 'src/Images/icons/common/search.svg';
import 'src/style/sidebar.css';
import { useMediaQuery } from '@mui/material';
import { CustomToolTip } from 'src/utils/CustomToolTip';
import { useNavigate } from 'react-router-dom';
import getColorCode from 'src/utils/GetThemeColor';
import { Modal } from 'react-bootstrap';
import ProductPopover from 'src/components/ProductPopover';

function Navbar() {
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantName = authReducer.userData.tenant.name;
  const themeColor = authReducer?.userData?.tenant?.theme;
  const isMobile = useMediaQuery('(max-width:600px)');
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [productPopoverAnchor, setProductPopoverAnchor] = useState(null);

  const isSettingsIconActive = useSelector(
    (state) => state.SettingsReducer.isSettingsIconActive,
  );

  const moveToSettings = () => {
    if (!isSettingsIconActive) {
      navigate('/settings/');
    } else {
      navigate(-1);
    }
  };

  const toggleProductPopover = (event) => {
    setProductPopoverAnchor(productPopoverAnchor ? null : event.currentTarget);
  };

  return (
    <div className="div-space-between">
      {isMobile && (
        <IconButton>
          <MobileSidebar />
        </IconButton>
      )}
      {!isMobile && (
        <IconButton>
          <div className="left-padding div-flex-row cg-20 div-align-center">
            <button
              aria-label="Open product launcher"
              className="icon-btn-none"
              onClick={toggleProductPopover}
            >
              <NineDotsLogo className="icon-white icon-size-xxl" />
            </button>
            <ProductPopover
              toggleProductPopover={() => setProductPopoverAnchor(null)}
              openProductPopover={productPopoverAnchor}
            />
            <span className="text-xxl text-semi-bold text-white">
              {tenantName}
            </span>
          </div>
        </IconButton>
      )}
      <div className="div-flex-row cg-20 div-align-center">
        {isMobile ? (
          <div className="mobile-navbar-search">
            <SearchLogo
              className="icon-size-lg"
              color="white"
              onClick={() => setShowSearchModal(true)}
            />
            <Modal
              show={showSearchModal}
              onHide={() => {
                setShowSearchModal(false);
              }}
              dialogClassName="custom-global-search-modal px-4"
              size="md"
            >
              <div className="div-flex-column px-2 py-3">
                <div className="input-wrapper">
                  <input
                    name="mobileGlobalSearch"
                    type="text"
                    className="form-input-section w-100"
                    placeholder="Search..."
                  />
                  <span className="form-input-section-icon">
                    <SearchLogo
                      className="icon-size-lg"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          <div
            className={`navbar-search ${isHovered || isFocused ? 'expanded' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <SearchLogo
              className="icon-size-lg"
              color={getColorCode(themeColor)}
            />
            <input
              type="text"
              className="search-input"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              placeholder=" Search..."
            />
          </div>
        )}
        {!isMobile && (
          <>
            <hr className="partition" />
            {/* Settings Button */}
            <div className="nav-icon-container">
              <button
                aria-label="Settings"
                className={`${isSettingsIconActive ? 'nav-icon-selected border-none' : 'nav-icon-btn-none'}`}
                onClick={moveToSettings}
              >
                <CustomToolTip title="Setting" placement="bottom">
                  <SettingsLogo
                    className="icon-size-lg"
                    color={
                      isSettingsIconActive
                        ? getColorCode(themeColor)
                        : '#ffffff'
                    }
                  />
                </CustomToolTip>
              </button>
            </div>
            <hr className="partition" />
            <AccountPopover />
          </>
        )}
      </div>
    </div>
  );
}

export default Navbar;
